export const sized = (url, w) => (url?.includes("images.unsplash.com") ? url.replace(/([?&])w=\d+/, `$1w=${w}`) : url);

export const srcSet = (url, widths = [480, 900, 1600]) =>
  url?.includes("images.unsplash.com") ? widths.map((w) => `${sized(url, w)} ${w}w`).join(", ") : undefined;
